import React from "react";

function EqualsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentcolor"
        d="M6.004 9.976A1.01 1.01 0 015 8.973C5 8.47 5.44 8 6.004 8h11.043c.533 0 1.004.44 1.004.973a1.01 1.01 0 01-1.004 1.003H6.004zm11.043 4.016c.533 0 1.004.44 1.004 1.004 0 .533-.47 1.004-1.004 1.004H6.004C5.439 16 5 15.498 5 14.996c0-.533.44-1.004 1.004-1.004h11.043z"
      ></path>
    </svg>
  );
}

export default React.memo(EqualsIcon);
